import { useEffect, useMemo, useState, useContext } from 'react';
import { onAuthStateChanged, User as FirebaseUser } from 'firebase/auth';
import { app, auth, db, storage } from './config';
import { AuthContext, AuthContextType } from './auth';


export { auth, db, storage, app };

/** Devuelve el usuario actual de Firebase y estados de carga/error */
export function useUser() {
  const [user, setUser] = useState<FirebaseUser | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    }, (e) => {
      setError(e);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  return { user, loading, error };
}

/** Retorna la instancia de Firestore ya inicializada */
export function useFirestore() {
  return db;
}

/** Memoiza las instancias principales de Firebase */
export function useMemoFirebase<T>(factory: () => T, deps: React.DependencyList) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoized = useMemo(factory, deps);
  if (memoized && typeof memoized === 'object') {
    (memoized as any).__memo = true;
  }
  return memoized;
}

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
